import React, { createContext, useContext, useState } from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState(null);

  const openModal = (modalName) => {
    setActiveModal(modalName);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const isModalOpen = (modalName) => {
    return activeModal === modalName;
  };

  return (
    <ModalContext.Provider value={{ 
      activeModal,
      openModal, 
      closeModal,
      isModalOpen,
      // Shortcuts para cada modal
      openWhataKit: () => openModal('whatakit'),
      openEarlyPack: () => openModal('earlypack'),
      openWatt: () => openModal('watt'),
    }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

export default ModalContext;
